module.exports = __webpack_public_path__ + "img/fit2_series.ae0909e7.webp";